const Location = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.38527 0.803467C3.56566 0.804397 2.77987 1.1304 2.20032 1.70996C1.62076 2.28952 1.29475 3.0753 1.29382 3.89492C1.29382 6.54022 4.10423 8.53912 4.22368 8.62343C4.27154 8.6553 4.32777 8.67231 4.38527 8.67231C4.44278 8.67231 4.49901 8.6553 4.54687 8.62343C4.66632 8.53912 7.47673 6.54022 7.47673 3.89492C7.4758 3.0753 7.14979 2.28952 6.57023 1.70996C5.99068 1.1304 5.20489 0.804397 4.38527 0.803467V0.803467ZM4.38527 2.77075C4.60761 2.77075 4.82496 2.83668 5.00983 2.96021C5.19469 3.08373 5.33878 3.2593 5.42387 3.46472C5.50895 3.67013 5.53121 3.89616 5.48784 4.11423C5.44446 4.3323 5.3374 4.5326 5.18018 4.68982C5.02296 4.84704 4.82265 4.95411 4.60459 4.99748C4.38652 5.04086 4.16049 5.0186 3.95508 4.93351C3.74966 4.84842 3.57409 4.70434 3.45057 4.51947C3.32704 4.3346 3.26111 4.11726 3.26111 3.89492C3.26111 3.59677 3.37955 3.31084 3.59037 3.10001C3.80119 2.88919 4.08713 2.77075 4.38527 2.77075V2.77075Z"
        fill="#AEB9E1"
      />
    </svg>
  );
};

export default Location;
